// test116
(116 && 0);
